import { Injectable } from '@angular/core';
import { DataStorageService } from './data-storage.service';
import { SecurityService } from './security.service';
import { ConfigService } from './config.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Category } from '../models/category';
import { Device } from '../models/device';
import { Internet } from '../models/internet';
import { PhoneNumbersToBePortedRange } from '../models/phoneNumbersToBePortedRange';
import { NewPhoneNumbersRange } from '../models/newPhoneNumbersRange';
import { PPhosted } from '../models/PPhosted';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import {ThreeCX} from '../models/ThreeCX';
import {MicrosoftTeams} from '../models/MicrosoftTeams';
import {PeoplefoneBundle} from '../models/PeoplefoneBundle';
import {MitelHostedPrice} from '../models/MitelHostedPrice';
import {SipTrunk} from '../models/SipTrunk';
import { Datasim } from '../models/Datasim';
import { SBCplus } from '../models/SBCplus';
import { Mobile } from '../models/Mobile';
@Injectable()
export class ApiService {

  constructor(
    private dataStorageService: DataStorageService,
    private securityService: SecurityService,
    private configService: ConfigService,
    private http: HttpClient,
    private spinner: NgxSpinnerService) {
  }

  /**-INTERNET--------------------------------------------------------------------------------------------------------*/
  getInternet(offerID: number, type: string): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/internet'
      + '?type='
      + type;
    return new Promise<any>((resolve, reject) => {
      this.http.get<Internet[]>(url).subscribe(response => {
        const effect = [];
        if (type === 'CYBERLINK') {
          response.map(e => {
            const f = e;
            f.totalMonthlyCost = 0;
            f.totalMonthlyCost += e.technologyMonthly;
            f.totalMonthlyCost += e.ipAddressMonthly;
            f.totalMonthlyCost += e.slaLevelMonthly ? e.slaLevelMonthly : 0;
            f.totalMonthlyCost += e.routerMonthly;
            f.totalMonthlyCost += e.supportTimeMonthly;
            f.totalMonthlyCost += e.endToendMonthlyCost;
            f.totalMonthlyCost += e.dslMonthlyCost;
            f.totalMonthlyCost += e.simMonthlyCost;
            f.totalUniqueCost = 0;
            f.totalUniqueCost += e.routerUnique;
            f.totalUniqueCost += e.simUniqueCost;
            f.totalUniqueCost += e.technologyUnique;
            f.totalUniqueCost += e.ipAddressUnique;
            f.totalUniqueCost += e.slaLevelUnique ? e.slaLevelUnique : 0;
            f.totalUniqueCost += e.supportTimeUnique;
            effect.push(f);
          });
          this.dataStorageService.currentState.PPinternetCyberlink.internet = effect;
          resolve('done');
        } else if (type === 'IPWORLDCOM') {
          response.map(e => {
            const f = e;
            f.totalMonthlyCost = 0;
            f.totalMonthlyCost += e.technologyMonthly;
            f.totalMonthlyCost += e.ipAddressMonthly;
            f.totalMonthlyCost += e.slaLevelMonthly ? e.slaLevelMonthly : 0;
            f.totalMonthlyCost += e.routerMonthly;
            f.totalUniqueCost = 0;
            f.totalUniqueCost += e.routerUnique;
            f.totalUniqueCost += e.technologyUnique;
            f.totalUniqueCost += e.ipAddressUnique;
            f.totalUniqueCost += e.slaLevelUnique ? e.slaLevelUnique : 0;
            effect.push(f);
          });
          this.dataStorageService.currentState.PPinternetIPworldcom.internet = effect;
          resolve();
        }
      }, (error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken()
            .then(() => this.getInternet(offerID, type).then(() => resolve()));
        } else {
          alert('Please complete the peoplefone internet');
          reject();
        }
      });
    });
  }

  postInternet(offerID: number, body: Internet): Promise<Internet> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/internet';
    delete body.id;
    if (body.type === 'IPWORLDCOM') {
      delete body.supportTime;
      delete body.supportTimeUnique;
      delete body.supportTimeMonthly;
    }
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<Internet>((resolve, reject) => {
        this.http.post<Internet>(url, body)
          .toPromise()
          .then(response => resolve(response)).catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.postInternet(offerID, body).then((data) => resolve(data)));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<Internet>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  putInternet(offerID: number, body: Internet | Internet[]): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/internet';
    if (!Array.isArray(body)) {
      body = [body];
    }
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, body)
          .toPromise()
          .then(() => resolve())
          .catch((error) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.putInternet(offerID, body).then(() => resolve()));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  deleteInternet(offerID: number, internetID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/internet/'
      + internetID;
    return new Promise<any>((resolve, reject) => {
      this.http.delete(url)
        .toPromise()
        .then(() => resolve())
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.deleteInternet(offerID, internetID).then(() => resolve()));
          } else {
            alert(error.message);
            reject();
          }
        });
    });
  }

  /**-CATEGORIES------------------------------------------------------------------------------------------------------*/
  getCategories() {
    const url = this.configService.host
      + '/api/device/category?partner-id='
      + this.securityService.authorization.user.partnerId;

    this.http.get(url).toPromise()
      .then((response) => {
        (<Category[]>response['categories']).map(element => {
          const category = new Category();
          category.id = element.id;
          category.name = element.name;
          this.dataStorageService.categories.push(category);
        });
      })
      .catch((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken()
            .then(() => this.getCategories());
        } else {
        //  alert(error.message);
        }
      });
  }

  getGlobalCategories() {
    const url = this.configService.host
      + '/api/device/category?partner-id='
      + 0;

    this.http.get(url).toPromise()
      .then((response) => {
        (<Category[]>response['categories']).map(element => {
          const category = new Category();
          category.id = element.id;
          category.name = element.name;
          this.dataStorageService.categoriesGlobal.push(category);
        });
      })
      .catch((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken()
            .then(() => this.getGlobalCategories());
        } else {
      //    alert(error.message);
        }
      });
  }

  putChangedCategoryNames(body): Promise<any> {
    const url = this.configService.host + '/api/device/category';
    return new Promise<any>((resolve, reject) => {
      this.http.put(url, body)
        .toPromise()
        .then(() => {
        }).catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.putChangedCategoryNames(body).then(() => resolve()));
          } else {
            alert(error.message);
            reject(error);
          }
        });
    });
  }

  /**DEVICES----------------------------------------------------------------------------------------------------------*/
  getDevices(partnerId: number, categoryId?: number, myArticles?: boolean): Promise<Device[]> {
    let url;
    if (myArticles) {
      url = this.configService.host
        + '/api/device?partner-id='
        + partnerId;
    } else {
      return new Promise<Device[]>((resolve, reject) => {
        const mappedResponse = [];
        if (categoryId === undefined) {
          reject();
        } else {
          url = this.configService.host
            + '/api/device?partner-id='
            + partnerId
            + '&category-id='
            + categoryId
            + '&page-size=1000';
          this.dataStorageService.devices = [];
          this.http.get(url)
            .toPromise().then(res => {
              res['records'].map(elem => {
                const device = new Device();
                device.id = elem['id'];
                device.articleNo = elem['articleNo'];
                device.articleUrl = elem['articleUrl'];
                device.categoryId = categoryId;
                device.name = elem['name'];
                device.description = elem['description'];
                device.manufacturer = elem['manufacturer'];
                device.distributor = elem['distributor'];
                device.purchasePrice = (elem['purchasePrice'] === null) ? 0 : elem['purchasePrice'];
                device.salePrice = elem['salePrice'];
                device.visible = elem['visible'];
                device.imageUrl = elem['imageUrl'];
                device.partnerId = elem['partnerId'];
                device.parentDeviceId = elem['parentDeviceId'];
                device.hasChildrenDevices = elem['hasChildrenDevices'];
                mappedResponse.push(device);
              });
              resolve(mappedResponse);
            }).catch((error: HttpErrorResponse) => {
              if (error.status === 401) {
                this.securityService.refreshToken()
                  .then(() => this.getDevices(partnerId, categoryId, myArticles)
                    .then((data) => resolve(data)));
              } else {
           //     alert(error.message);
                reject(error);
              }
            });
        }
      });
    }
  }

  postDevice(body: Object): Promise<Device> {
    const url = this.configService.host + '/api/device';
    return new Promise<Device>((resolve, reject) => {
      this.http.post(url, body)
        .toPromise()
        .then(res => {
          const dev = new Device();
          dev.id = res['id'];
          resolve(dev);

          this.dataStorageService.success = !this.dataStorageService.success;
          setTimeout(() => this.dataStorageService.success = false, 1000);
        }).catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.postDevice(body).then((dev) => resolve(dev)));
          } else {
            alert(error.message);
            reject(error);
          }
        });
    });
  }

  putDevice(deviceID: number, body: Object): Promise<any> {

    const url = this.configService.host + '/api/device/' + this.dataStorageService.editedDevice.id;
    return new Promise<any>((resolve, reject) => {
      this.http.put(url, body)
        .toPromise()
        .then(() => {
          resolve();

          this.dataStorageService.success = !this.dataStorageService.success;
          setTimeout(() => this.dataStorageService.success = false, 1000);
        })
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.putDevice(deviceID, body).then(() => resolve()));
          } else {
            alert(error.error);
            reject(error);
          }
        });
    });
  }

  putVisible(deviceID: number, status): Promise<any> {
    const url = this.configService.host
      + '/api/device/'
      + deviceID;
    const body = {
      'visible': status
    };

    return new Promise<any>((resolve, reject) => {
      this.http.put(url, body)
        .toPromise()
        .then(() => resolve())
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.putVisible(deviceID, status).then(() => resolve()));
          } else {
            alert(error.message);
            reject(error);
          }
        });
    });
  }

  deleteDevice(deviceID: number): Promise<any> {
    const url = this.configService.host
      + '/api/device/'
      + deviceID;
    return new Promise<any>((resolve, reject) => {
      this.http.delete(url)
        .toPromise()
        .then(() => {
          resolve();
        })
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken().then(() => {
              this.deleteDevice(deviceID)
                .then(() => resolve());
            });
          } else {
            alert(error.message);
            reject(error);
          }
        });
    });
  }

  /**TO-BE-PORTED-----------------------------------------------------------------------------------------------------*/
  getPortedNumbers(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/ported-numbers';
    return new Promise<any>((resolve, reject) => {
      this.http.get<PhoneNumbersToBePortedRange[]>(url)
        .toPromise()
        .then((response) => {
          this.dataStorageService.currentState.phoneNumbersToBePorted.range = response;
          resolve();
        }).catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getPortedNumbers(offerID).then(() => resolve()));
          } else {
            alert(error.message);
            reject(error);
          }
        });
    });
  }

  postPortedNumbers(offerID: number, body?: PhoneNumbersToBePortedRange): Promise<PhoneNumbersToBePortedRange> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/ported-numbers';
    body = body ? body : new PhoneNumbersToBePortedRange();
    delete body.id;
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<PhoneNumbersToBePortedRange>((resolve, reject) => {
        this.http.post<PhoneNumbersToBePortedRange>(url, body)
          .toPromise()
          .then(response => resolve(response))
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.postPortedNumbers(offerID).then(data => resolve(data)));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<PhoneNumbersToBePortedRange>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  putPortedNumbers(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/ported-numbers';
    const body = this.dataStorageService.currentState.phoneNumbersToBePorted.range;
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, body)
          .toPromise()
          .then(() => resolve())
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.putPortedNumbers(offerID).then(() => resolve()));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  deletePortedNumbers(offerID: number, rangeID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/ported-numbers/'
      + rangeID;
    return new Promise<any>((resolve, reject) => {
      this.http.delete(url)
        .toPromise()
        .then(() => resolve())
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.deletePortedNumbers(offerID, rangeID).then(() => resolve()));
          } else {
            alert(error.message);
            reject(error);
          }
        });
    });
  }

  /**NEW-PHONE-NUMBERS------------------------------------------------------------------------------------------------*/
  getNewNumbers(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/new-numbers';
    return new Promise<any>((resolve, reject) => {
      this.http.get<NewPhoneNumbersRange[]>(url)
        .toPromise()
        .then((response) => {
          this.dataStorageService.currentState.newPhoneNumber.range = response;
          resolve();
        }).catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getNewNumbers(offerID).then(() => resolve()));
          } else {
            alert(error.message);
            reject(error);
          }
        });
    });
  }

  postNewNumbers(offerID: number, body?: NewPhoneNumbersRange): Promise<NewPhoneNumbersRange> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/new-numbers';
    body = body ? body : new NewPhoneNumbersRange();
    delete body.id;
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<NewPhoneNumbersRange>((resolve, reject) => {
        this.http.post<NewPhoneNumbersRange>(url, body)
          .toPromise()
          .then((response) => resolve(response))
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.postNewNumbers(offerID).then((data) => resolve(data)));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<NewPhoneNumbersRange>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  putNewNumbers(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/new-numbers';
    const body = this.dataStorageService.currentState.newPhoneNumber.range;
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, body)
          .toPromise()
          .then(() => resolve())
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.putNewNumbers(offerID).then(() => resolve()));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  deleteNewNumbers(offerID: number, rangeID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/new-numbers/'
      + rangeID;
    return new Promise<any>((resolve, reject) => {
      this.http.delete(url)
        .toPromise()
        .then(() => resolve())
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.deleteNewNumbers(offerID, rangeID).then(() => resolve()));
          } else {
            alert(error.message);
            reject(error);
          }
        });
    });
  }

  /**PEOPLEFONE-HOSTED------------------------------------------------------------------------------------------------*/
  getPPHosted(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/pf-hosted';
    return new Promise<any>((resolve, reject) => {
      this.http.get<PPhosted>(url)
        .toPromise().then((response) => {
          this.dataStorageService.currentState.PPhosted.usersIpTerminal = response.usersIpTerminal;
          this.dataStorageService.currentState.PPhosted.usersFax2Email = response.usersFax2Email;
          this.dataStorageService.currentState.PPhosted.usersAnalogFax = response.usersAnalogFax;
          this.dataStorageService.currentState.PPhosted.usersCentralizedVoiceMail = response.usersCentralizedVoiceMail;
          this.dataStorageService.currentState.PPhosted.usersReserve = response.usersReserve;
          this.dataStorageService.currentState.PPhosted.usersAvailable = response.usersAvailable;
          this.dataStorageService.currentState.PPhosted.nodes = response.nodes;
          this.dataStorageService.currentState.PPhosted.usersMonthlyCost = response.usersMonthlyCost;
          this.dataStorageService.currentState.PPhosted.nodesMonthlyCost = response.nodesMonthlyCost;

          this.dataStorageService.currentState.PPhosted.softphones = response.softphones;
          this.dataStorageService.currentState.PPhosted.softphoneMonthlyCost = response.softphoneMonthlyCost;
          this.dataStorageService.currentState.PPhosted.connectorApi = response.connectorApi;
          this.dataStorageService.currentState.PPhosted.connectorStandard = response.connectorStandard;
          this.dataStorageService.currentState.PPhosted.connectorApiMonthlyCost = response.connectorApiMonthlyCost;
          this.dataStorageService.currentState.PPhosted.connectorStandardMonthlyCost = response.connectorStandardMonthlyCost;
          this.dataStorageService.currentState.PPhosted.connectorStandardUniqueCost = response.connectorStandardUniqueCost;

          resolve();
        }).catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getPPHosted(offerID).then(() => resolve()));
          } else {
            alert('Please complete peoplefone Hosted');
            reject(error);
          }
        });
    });
  }

  putPPHosted(offerID: number, body?: PPhosted): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/pf-hosted';

    body = body ? body : this.dataStorageService.currentState.PPhosted;
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, body)
          .toPromise()
          .then(() => resolve())
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.putPPHosted(offerID).then(() => resolve()));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  /**FLAT-RATE-HOSTED-------------------------------------------------------------------------------------------------*/
  getFRHosted(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/biz-flrat-hosted';
    return new Promise<any>((resolve, reject) => {
      this.http.get<{
        networkType: string,
        unitCount: number,
        unitMonthlyCost: number,
        unitFixnetMinutes: number,
        unitMobilenetMinutes: number
      }>(url)
        .toPromise().then((response) => {
          const flatRate = this.dataStorageService.currentState.businessFlatRateHosted;
          flatRate.chosenType = response.networkType;
          flatRate.numberOfFlatRates = response.unitCount;
          flatRate.unitMonthlyCost = response.unitMonthlyCost;
          flatRate.fixnetMinutes = response.unitFixnetMinutes;
          flatRate.fixnetMobileMinutes = response.unitMobilenetMinutes;
          resolve();
        }).catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getFRHosted(offerID).then(() => resolve()));
          } else {
            alert('Please complete peoplefone Flat Hosted');
            reject(error);
          }
        });
    });
  }

  putFRHosted(offerID: number, body?): Promise<any> {
    const type = body ? body.networkType : this.dataStorageService.currentState.businessFlatRateHosted.chosenType;
    const pricingElement = this.dataStorageService.flatRateHostedPricing.filter(e => e.networkType === type)[0];
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/biz-flrat-hosted';
    body = body ? body : {
      networkType: type,
      unitCount: this.dataStorageService.currentState.businessFlatRateHosted.numberOfFlatRates,
      unitFixnetMinutes: pricingElement.unitFixnetMinutes,
      unitMobilenetMinutes: pricingElement.unitMobilenetMinutes,
      unitMonthlyCost: pricingElement.unitMonthlyCost
    };
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, body)
          .toPromise()
          .then((r) => resolve(r))
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.putFRHosted(offerID).then(() => resolve()));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  /**FLAT-RATE-SIP-TRUNK-------------------------------------------------------------------------------------------------*/
  getFRSipTrunk(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/biz-flrat-siptrunk';
    return new Promise<any>((resolve, reject) => {
      this.http.get<{
        networkType: string,
        unitCount: number,
        unitMonthlyCost: number,
        unitFixnetMinutes: number,
        unitMobilenetMinutes: number
      }>(url)
        .toPromise().then((response) => {
          const flatRate = this.dataStorageService.currentState.businessFlatRateSipTrunk;
          flatRate.chosenType = response.networkType;
          flatRate.numberOfFlatRates = response.unitCount;
          flatRate.unitMonthlyCost = response.unitMonthlyCost;
          flatRate.fixnetMinutes = response.unitFixnetMinutes;
          flatRate.fixnetMobileMinutes = response.unitMobilenetMinutes;
          resolve();
        }).catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getFRSipTrunk(offerID).then(() => resolve()));
          } else {
            alert('Please complete peoplefone Flat Trunk');
            reject(error);
          }
        });
    });
  }

  putFRSipTrunk(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/biz-flrat-siptrunk';
    const type = this.dataStorageService.currentState.businessFlatRateSipTrunk.chosenType;
    const pricingElement = this.dataStorageService.flatRateSipTrunkPricing.filter(e => e.networkType === type)[0];
    const body = {
      networkType: type,
      unitCount: this.dataStorageService.currentState.businessFlatRateSipTrunk.numberOfFlatRates,
      unitFixnetMinutes: pricingElement.unitFixnetMinutes,
      unitMobilenetMinutes: pricingElement.unitMobilenetMinutes,
      unitMonthlyCost: pricingElement.unitMonthlyCost
    };
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, body)
          .toPromise()
          .then(() => resolve())
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.putFRSipTrunk(offerID).then(() => resolve()));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  /**PEOPLEFONE-3CX------------------------------------------------------------------------------------------------*/
  getThreeCX(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/3cx';
    return new Promise<any>((resolve, reject) => {
      this.http.get<ThreeCX>(url)
        .toPromise().then((response) => {
        this.dataStorageService.currentState.threeCX.type = response.type;
        this.dataStorageService.currentState.threeCX.term = response.term;
        this.dataStorageService.currentState.threeCX.sc = response.sc;
        this.dataStorageService.currentState.threeCX.addon = response.addon;
        this.dataStorageService.currentState.threeCX.costMonthlySub = response.costMonthlySub;
        this.dataStorageService.currentState.threeCX.costMonthlyAddon = response.costMonthlyAddon;
        resolve();
      }).catch((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken()
            .then(() => this.getPPHosted(offerID).then(() => resolve()));
        } else {
          alert('Please complete peoplefone 3cx');
          reject(error);
        }
      });
    });
  }

  putThreeCX(offerID: number, body?: ThreeCX): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/3cx';

    body = body ? body : this.dataStorageService.currentState.threeCX;
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, body)
          .toPromise()
          .then(() => resolve())
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.putThreeCX(offerID).then(() => resolve()));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }


  /**Microsoft Teams----------------------------------------------------------------------------------------------*/
  getMsTeams(offerID: number, type = 'msTeams'): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/'+type;
    return new Promise<any>((resolve, reject) => {
      this.http.get<MicrosoftTeams>(url)
        .toPromise().then((response) => {
          if(type === 'msTeams') {
            this.dataStorageService.currentState.microsoftTeams.type = response.type;
            this.dataStorageService.currentState.microsoftTeams.users = response.users;
            this.dataStorageService.currentState.microsoftTeams.costMonthly = response.costMonthly;
            this.dataStorageService.currentState.microsoftTeams.costUnique = response.costUnique;
          } else {
            this.dataStorageService.currentState.operatorConnect.type = response.type;
            this.dataStorageService.currentState.operatorConnect.users = response.users;
            this.dataStorageService.currentState.operatorConnect.costMonthly = response.costMonthly;
            this.dataStorageService.currentState.operatorConnect.costUnique = response.costUnique;
          }

        resolve();
      }).catch((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken()
            .then(() => this.getMsTeams(offerID, type).then(() => resolve()));
        } else {
          alert('Please complete peoplefone Teams');
          reject(error);
        }
      });
    });
  }

  putSBCplus(offerID: number, sbc: SBCplus): Promise<any> {
    const url = this.configService.host
    + '/api/offer/'
    + offerID
    + '/sbcplus';

    return new Promise<any>((resolve, reject) => {
      this.http.put<SBCplus>(url, sbc)
        .toPromise().then((response) => {
            this.dataStorageService.currentState.sbcplus = response
        resolve();
      }).catch((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken()
            .then(() => this.putSBCplus(offerID, sbc).then(() => resolve()));
        } else {
          alert('Please complete peoplefone Sbcplus');
          reject(error);
        }
      });
    });
  }

  getSbcplus(offerID: number): Promise<any> {
    const url = this.configService.host
    + '/api/offer/'
    + offerID
    + '/sbcplus';

    return new Promise<any>((resolve, reject) => {
      this.http.get<SBCplus>(url)
        .toPromise().then((response) => {
            this.dataStorageService.currentState.sbcplus = response
        resolve();
      }).catch((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken()
            .then(() => this.getSbcplus(offerID).then(() => resolve()));
        } else {
          alert('Please complete peoplefone Sbcplus');
          reject(error);
        }
      });
    });
  }



  getMitelHosted(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/mitelHosted';
    return new Promise<any>((resolve, reject) => {
      this.http.get<MitelHostedPrice>(url)
        .toPromise().then((response) => {
        this.dataStorageService.currentState.pfMitelHosted.hosted = response.hosted;
        this.dataStorageService.currentState.pfMitelHosted.hosted_monthly = response.hosted_monthly;
        this.dataStorageService.currentState.pfMitelHosted.hosted_unique = response.hosted_unique;
        this.dataStorageService.currentState.pfMitelHosted.cloudLink = response.cloudLink;
        this.dataStorageService.currentState.pfMitelHosted.cloundLink_monthly = response.cloundLink_monthly;
        this.dataStorageService.currentState.pfMitelHosted.cloundLink_unique = response.cloundLink_unique;
        this.dataStorageService.currentState.pfMitelHosted.checkCloundLink = response.checkCloundLink;
        this.dataStorageService.currentState.pfMitelHosted.mbgTeleworker = response.mbgTeleworker;
        this.dataStorageService.currentState.pfMitelHosted.mbgTeleworker_monthly = response.mbgTeleworker_monthly;
        this.dataStorageService.currentState.pfMitelHosted.mbgTeleworker_unique = response.mbgTeleworker_unique;
        this.dataStorageService.currentState.pfMitelHosted.oipCTI = response.oipCTI;
        this.dataStorageService.currentState.pfMitelHosted.oipCTI_monthly = response.oipCTI_monthly;
        this.dataStorageService.currentState.pfMitelHosted.oipCTI_unique = response.oipCTI_unique;
        this.dataStorageService.currentState.pfMitelHosted.vpn_link = response.vpn_link;
        this.dataStorageService.currentState.pfMitelHosted.vpn_link_input = response.vpn_link_input;
        this.dataStorageService.currentState.pfMitelHosted.vpn_link_monthly = response.vpn_link_monthly;
        this.dataStorageService.currentState.pfMitelHosted.vpn_link_unique = response.vpn_link_unique;
        resolve();
      }).catch((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken()
            .then(() => this.getPfBundle(offerID).then(() => resolve()));
        } else {
          alert('Please complete peoplefone Mitell Hosted');
          reject(error);
        }
      });
    });
  }
  putMitelHosted(offerID: number, body?: MitelHostedPrice): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/mitelHosted';

    body = body ? body : this.dataStorageService.currentState.pfMitelHosted;
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, body)
          .toPromise()
          .then(() => resolve())
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.putMitelHosted(offerID).then(() => resolve()));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  putMsTeams(offerID: number, body?: MicrosoftTeams, type='msTeams'): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/'+type;

    body = body ? body : (type === 'msTeams' ? this.dataStorageService.currentState.microsoftTeams : this.dataStorageService.currentState.operatorConnect);
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, body)
          .toPromise()
          .then(() => resolve())
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.putMsTeams(offerID, body, type).then(() => resolve()));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  /**Peoplefone Bundle----------------------------------------------------------------------------------------------*/
  getPfBundle(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/pfBundle';
    return new Promise<any>((resolve, reject) => {
      this.http.get<PeoplefoneBundle>(url)
        .toPromise().then((response) => {
        this.dataStorageService.currentState.peoplefoneBundle.type = response.type;
        this.dataStorageService.currentState.peoplefoneBundle.spec = response.spec;
        this.dataStorageService.currentState.peoplefoneBundle.numbersPorting = response.numbersPorting;
        this.dataStorageService.currentState.peoplefoneBundle.router = response.router;
        this.dataStorageService.currentState.peoplefoneBundle.routerCostUnique = response.routerCostUnique;
        this.dataStorageService.currentState.peoplefoneBundle.costMonthly = response.costMonthly;
        this.dataStorageService.currentState.peoplefoneBundle.costUnique = response.costUnique;
        resolve();
      }).catch((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken()
            .then(() => this.getPfBundle(offerID).then(() => resolve()));
        } else {
          alert('Please complete peoplefone Flat Bundle');
          reject(error);
        }
      });
    });
  }

  putPfBundle(offerID: number, body?: PeoplefoneBundle): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/pfBundle';

    body = body ? body : this.dataStorageService.currentState.peoplefoneBundle;
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, body)
          .toPromise()
          .then(() => resolve())
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.putPfBundle(offerID).then(() => resolve()));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  /**PEOPLEFONE-Sip-TRUNK------------------------------------------------------------------------------------------------*/
  getSipTrunk(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/sipTrunk';
    return new Promise<any>((resolve, reject) => {
      this.http.get<SipTrunk[]>(url)
        .toPromise().then((response) => {
        this.dataStorageService.currentState.sipTrunks = response
        resolve();
      }).catch((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken()
            .then(() => this.getSipTrunk(offerID).then(() => resolve()));
        } else {
          alert('Please complete peoplefone sip trunk');
          reject(error);
        }
      });
    });
  }

  deleteSipTrunk(offerID: number, trunkID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/sipTrunk/'+trunkID;
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.delete(url)
          .toPromise()
          .then(result => resolve(result))
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.deleteSipTrunk(offerID, trunkID).then(res => resolve(res)));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  putSipTrunk(offerID: number, body: SipTrunk): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/sipTrunk';
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<any>((resolve, reject) => {
        this.http.put(url, body)
          .toPromise()
          .then(result => resolve(result))
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.putSipTrunk(offerID, body).then(res => resolve(res)));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }


  /**PRINT-DOC-FILE---------------------------------------------------------------------------------------------------*/

  getPrintOffer(offerID: number, exportHasNoVAT: boolean): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/print?exportHasNoVAT='+exportHasNoVAT;

    return new Promise<any>((resolve, reject) => {
      this.spinner.show();
      this.http.get(url, { responseType: 'blob' })
        .toPromise()
        .then(response => {
          this.saveFile(response);
          resolve(this.spinner.hide());
        })
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.getPrintOffer(offerID, exportHasNoVAT).then(() => resolve()));
          } else {
            alert(error.message);
            this.spinner.hide();
            reject(error);
          }
        });
    });
  }

  saveFile(blobContent) {
    const blob = new Blob([blobContent], { type: 'application/octet-stream' });
    saveAs(blob,
      'Offer '
      + this.dataStorageService.currentState.offerNumber
      // tslint:disable-next-line:max-line-length
      + (this.dataStorageService.currentState.customerProfile.name !== null ? ' ' + this.dataStorageService.currentState.customerProfile.name : '')
      + '.docx');
  }

  /**PEOPLEFONE-DATASIM------------------------------------------------------------------------------------------------*/
  getDatasim(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/datasim';
    return new Promise<any>((resolve, reject) => {
      this.http.get<Datasim[]>(url)
        .toPromise().then((response) => {
          //debugger
        this.dataStorageService.currentState.datasims = response
        // type = response.type;
        // this.dataStorageService.currentState.datasim.productOption = response.productOption;
        // this.dataStorageService.currentState.datasim.costMonthly = response.costMonthly;
        // this.dataStorageService.currentState.datasim.costUnique = response.costUnique;
        resolve();
      }).catch((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken()
            .then(() => this.getDatasim(offerID).then(() => resolve()));
        } else {
          alert('Please complete peoplefone datasim');
          reject(error);
        }
      });
    });
  }

  postDatasim(offerID: number, body?: Datasim): Promise<Datasim> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/datasim';
    body = body ? body : new Datasim();
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<Datasim>((resolve, reject) => {
        this.http.post<Datasim>(url, body)
          .toPromise()
          .then(response => resolve(response))
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.postDatasim(offerID).then(data => resolve(data)));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<Datasim>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  deleteDatasim(offerID: number, datasimID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/datasim/'
      + datasimID;
    return new Promise<any>((resolve, reject) => {
      this.http.delete(url)
        .toPromise()
        .then(() => resolve())
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.deleteDatasim(offerID, datasimID).then(() => resolve()));
          } else {
            alert(error.message);
            reject();
          }
        });
    });
  }

  /**PEOPLEFONE-MOBILE------------------------------------------------------------------------------------------------*/
  getMobile(offerID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/mobile';
    return new Promise<any>((resolve, reject) => {
      this.http.get<Mobile[]>(url)
        .toPromise().then((response) => {
          //debugger
        this.dataStorageService.currentState.mobiles = response;
        resolve();
      }).catch((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.securityService.refreshToken()
            .then(() => this.getMobile(offerID).then(() => resolve()));
        } else {
          alert('Please complete peoplefone mobile');
          reject(error);
        }
      });
    });
  }

  postMobile(offerID: number, body?: Mobile): Promise<Mobile> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/mobile';
    body = body ? body : new Mobile();
    if (this.dataStorageService.currentState.status === 'OPEN') {
      return new Promise<Mobile>((resolve, reject) => {
        this.http.post<Mobile>(url, body)
          .toPromise()
          .then(response => resolve(response))
          .catch((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.securityService.refreshToken()
                .then(() => this.postMobile(offerID).then(data => resolve(data)));
            } else {
              if (error.status >= 400 && error.status < 500) {
                alert('ERROR: Please contact with your administrator');
              } else {
                alert('Please check your internet connection');
              }
              reject();
            }
          });
      });
    } else {
      return new Promise<Mobile>((resolve, reject) => {
        alert('You can not modify WON/LOST offer');
        reject();
      });
    }
  }

  deleteMobile(offerID: number, mobileID: number): Promise<any> {
    const url = this.configService.host
      + '/api/offer/'
      + offerID
      + '/mobile/'
      + mobileID;
    return new Promise<any>((resolve, reject) => {
      this.http.delete(url)
        .toPromise()
        .then(() => resolve())
        .catch((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.securityService.refreshToken()
              .then(() => this.deleteMobile(offerID, mobileID).then(() => resolve()));
          } else {
            alert(error.message);
            reject();
          }
        });
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/api.service.ts